'use client';
/** `clsx` in six lines. The kit has no class-name dependency and does not need one. */
export function cx(...parts) {
    return parts.filter(Boolean).join(' ');
}
/**
 * Merge custom properties into a style object.
 *
 * React's `CSSProperties` has no index signature for `--*`, so every call site
 * would otherwise carry its own cast. Doing it once here also means the
 * `undefined` filtering is consistent: an absent value must not emit
 * `--bk-x: undefined`, which browsers keep as an invalid declaration and which
 * then shadows the cascade for that property.
 */
export function cssVars(vars, base) {
    const out = {};
    for (const [key, value] of Object.entries(vars)) {
        if (value !== undefined && value !== null && value !== '')
            out[key] = value;
    }
    return { ...(base ?? {}), ...out };
}
//# sourceMappingURL=style.js.map